import { Paths } from "../constants/UrlConstants";

const CustomisedPreference = {
    Heading: null,
    Links:[
      { Text: "HOW I'D LIKE TO BE CONTACTED", Link: Paths.MyProfileContactPreferences },
      { Text: "My Communications Needs", Link: Paths.CommunicationPreference },
    ],
    LinksWithoutCommunicationNeed:[
      { Text: "HOW I'D LIKE TO BE CONTACTED", Link: Paths.MyProfileContactPreferences },
    ]
  };
  
export default CustomisedPreference;